import React from "react";
import "./carousel.scss";
import registernowImg from "../../assets/registernowImg.png";
import { useNavigate } from "react-router";

const Carousel = () => {
  let navigate = useNavigate();
  return (
    <div className="imgContainer d-flex justify-content-center align-items-center flex-column">
      <div className="contentWrapper">
        <div className="row">
          <div className="col-sm-8 text-white">
            <div className="mb-2">
              More Than 5,000 new Registration every Year{" "}
            </div>
            <div className="mb-2">
              » Our application is only for Kumbhar Caste{" "}
            </div>
            <div className="mb-2">
              » Profile Matching & Express Interest facilitie sare available
            </div>
            <div className="mb-2">
              » No need to register your name with any other application
            </div>
            <div className="mb-2">
              » Thousands of marriages are settled through our application as of
              today
            </div>
          </div>
          <div className="col-sm-4 registerImg">
            <img src={registernowImg} alt="" />
          </div>
        </div>
      </div>
      <div className="text-center mt-3">
        <span
          className="buttonClass registerBtn"
          onClick={() => {
            navigate("/register");
          }}
        >
          CLICK HERE TO REGISTER YOURSELF NOW
        </span>
      </div>
    </div>
  );
};

export default Carousel;
